// extracted by mini-css-extract-plugin
export default {"SessionPage__spinner":"SessionPage_SessionPage__spinner__7VgSO"};